module.exports = __webpack_public_path__ + "static/media/CHILDREN PLAY AREA SMALL.907684b6.png";